import { createRouter, createWebHashHistory } from "vue-router";

import Home from "../views/Home/Home.vue";
import Cooperate from "../views/Home/Cooperate.vue";
import Cart from "../views/cart/Cart.vue";
import Billing from "../views/cart/Billing.vue";
import Checkout from "../views/cart/Checkout.vue";
import Corporate from "../views/cart/Corporate.vue";

import BaseInfo from "../views/PersonalCenter/MyAccount/BaseInfo.vue";
import Vip from "../views/PersonalCenter/MyAccount/Vip.vue";
import Address from "../views/PersonalCenter/MyAccount/Address.vue";
import Collection from "../views/PersonalCenter/Collection.vue";
import Invoice from "../views/PersonalCenter/Invoice/Invoice.vue";
import InvoiceGoods from "../views/PersonalCenter/Invoice/InvoiceGoods.vue";
import Title from "../views/PersonalCenter/Invoice/Title.vue";
import TitleEdit from "../views/PersonalCenter/Invoice/TitleEdit.vue";
import InvoiceApply from "../views/PersonalCenter/Invoice/InvoiceApply.vue";
import InvoiceDetail from "../views/PersonalCenter/Invoice/InvoiceDetail.vue";
import IncomeDetail from "../views/PersonalCenter/IncomeDetail.vue";
import SubManage from "../views/PersonalCenter/SubManage/SubManage.vue";
import SubOrder from "../views/PersonalCenter/SubManage/SubOrder.vue";
import ServiceTerm from "../views/PersonalCenter/ServiceTerm/ServiceTerm.vue";
import ServiceDetail from "../views/PersonalCenter/ServiceTerm/ServiceDetail.vue";
import HelpCenter from "../views/PersonalCenter/HelpCenter/HelpCenter.vue";
import HelpDetail from "../views/PersonalCenter/HelpCenter/HelpDetail.vue";
import AboutUs from "../views/PersonalCenter/AboutUs.vue";
import CustomerSer from "../views/PersonalCenter/CustomerSer.vue";
import Order from "../views/PersonalCenter/MyOrder/Order.vue";
import Refund from "../views/PersonalCenter/MyOrder/Refund.vue";
import RefundStatus from "../views/PersonalCenter/MyOrder/RefundStatus.vue";
import LogDetail from "../views/PersonalCenter/MyOrder/LogDetail.vue";
import OrderDetail from "../views/PersonalCenter/MyOrder/OrderDetail.vue";
import OrderExp from "../views/PersonalCenter/MyOrder/OrderExp.vue";
import SendReport from "../views/PersonalCenter/MyOrder/SendReport.vue";

import Activities from "../views/Activities/Activities.vue";
import BrandShow from "../views/Activities/BrandShow.vue";
import BrandShowDetail from "../views/Activities/BrandShowDetail.vue";
import GroupProductDetail from "../views/Activities/GroupProductDetail.vue";
import PretermProductDetail from "../views/Activities/PretermProductDetail.vue";
import TodayProductDetail from "../views/Activities/TodayProductDetail.vue";
import ForecastDetail from "../views/Activities/ForecastDetail.vue";
import NewProductDetail from "../views/Activities/NewProductDetail.vue";
import Pay from "../views/Activities/Pay.vue";
import FindProduct from "../views/FindProduct/FindProduct.vue";
import FindProductDetail from "../views/FindProduct/FindProductDetail.vue";

import Login from "../views/Login/index.vue";
import RetrievePassword from "../views/Login/RetrievePassword.vue";
import Enroll from "../views/Login/Enroll.vue";
import Message from "../views/Message/index.vue";
import NewInstitutions from "../views/Login/NewInstitutions.vue";

import NewLogin from "../views/Login/NewLogin.vue";
import Purchase from "../views/Login/Purchase.vue";

import VueCookies from "vue-cookies";
const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
	},
	{
		path: "/Cooperate",
		name: "Cooperate",
		component: Cooperate,
	},
	{
		path: "/Cart",
		name: "Cart",
		component: Cart,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Billing",
		name: "Billing",
		component: Billing,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Checkout",
		name: "Checkout",
		component: Checkout,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Corporate",
		name: "Corporate",
		component: Corporate,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/BaseInfo",
		name: "BaseInfo",
		component: BaseInfo,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Vip",
		name: "Vip",
		component: Vip,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Address",
		name: "Address",
		component: Address,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Collection",
		name: "Collection",
		component: Collection,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Invoice",
		name: "Invoice",
		component: Invoice,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/InvoiceGoods",
		name: "InvoiceGoods",
		component: InvoiceGoods,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Title",
		name: "Title",
		component: Title,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/TitleEdit",
		name: "TitleEdit",
		component: TitleEdit,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/InvoiceApply",
		name: "InvoiceApply",
		component: InvoiceApply,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/InvoiceDetail",
		name: "InvoiceDetail",
		component: InvoiceDetail,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/IncomeDetail",
		name: "IncomeDetail",
		component: IncomeDetail,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/SubManage",
		name: "SubManage",
		component: SubManage,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/SubOrder",
		name: "SubOrder",
		component: SubOrder,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/ServiceTerm",
		name: "ServiceTerm",
		component: ServiceTerm,
	},
	{
		path: "/ServiceDetail",
		name: "ServiceDetail",
		component: ServiceDetail,
	},
	{
		path: "/HelpCenter",
		name: "HelpCenter",
		component: HelpCenter,
	},
	{
		path: "/HelpDetail",
		name: "HelpDetail",
		component: HelpDetail,
	},
	{
		path: "/AboutUs",
		name: "AboutUs",
		component: AboutUs,
	},
	{
		path: "/CustomerSer",
		name: "CustomerSer",
		component: CustomerSer,
	},
	{
		path: "/Order",
		name: "Order",
		component: Order,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Refund",
		name: "Refund",
		component: Refund,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/RefundStatus",
		name: "RefundStatus",
		component: RefundStatus,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/LogDetail",
		name: "LogDetail",
		component: LogDetail,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/OrderDetail",
		name: "OrderDetail",
		component: OrderDetail,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/OrderExp",
		name: "OrderExp",
		component: OrderExp,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/SendReport",
		name: "SendReport",
		component: SendReport,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Activities",
		name: "Activities",
		component: Activities,
	},
	{
		path: "/BrandShow",
		name: "BrandShow",
		component: BrandShow,
	},
	{
		path: "/BrandShowDetail",
		name: "BrandShowDetail",
		component: BrandShowDetail,
	},
	{
		path: "/GroupProductDetail",
		name: "GroupProductDetail",
		component: GroupProductDetail,
	},
	{
		path: "/PretermProductDetail",
		name: "PretermProductDetail",
		component: PretermProductDetail,
	},
	{
		path: "/TodayProductDetail",
		name: "TodayProductDetail",
		component: TodayProductDetail,
	},
	{
		path: "/ForecastDetail",
		name: "ForecastDetail",
		component: ForecastDetail,
	},
	{
		path: "/NewProductDetail",
		name: "NewProductDetail",
		component: NewProductDetail,
	},
	{
		path: "/Pay",
		name: "Pay",
		component: Pay,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/FindProduct",
		name: "FindProduct",
		component: FindProduct,
	},
	{
		path: "/FindProductDetail",
		name: "FindProductDetail",
		component: FindProductDetail,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/Login",
		name: "Login",
		component: Login,
	},
	{
		path: "/RetrievePassword",
		name: "RetrievePassword",
		component: RetrievePassword,
	},
	{
		path: "/Enroll",
		name: "Enroll",
		component: Enroll,
	},
	{
		path: "/Message",
		name: "Message",
		component: Message,
		meta: { requiresAuth: true },
		beforeEnter: (to, from, next) => {
			if (VueCookies.get("userinfo")) {
				next();
			} else {
				next({ name: "Login" });
			}
		},
	},
	{
		path: "/NewInstitutions",
		name: "NewInstitutions",
		component: NewInstitutions,
	},
	{
		path: "/NewLogin",
		name: "NewLogin",
		component: NewLogin,
	},
	{
		path: "/Purchase",
		name: "Purchase",
		component: Purchase,
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});
// 全局导航守卫
router.beforeEach((to, from, next) => {
	window.scrollTo(0, 0); // 跳转到顶部
	next();
});
export default router;
